(()=>{if(customElements.get('v7-json-animation'))return;
class StudioJsonAnimation extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.currentUrl = null;
    this.observer = null;
    this.resizeTimer = null;
    this.handleResize = this.handleResize.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.desktopUrl = this.getAttribute('animation-url') || '';
    this.mobileUrl = this.getAttribute('animation-url-mobile') || '';
    this.loop = this.readBoolean('loop', true);
    this.autoplay = this.readBoolean('autoplay', true);
    this.clickToPlay = this.readBoolean('click-to-play', false);
    this.speed = Number.parseFloat(this.getAttribute('speed')) || 1;

    if (!this.desktopUrl || !window.lottie?.loadAnimation) return;
    if (this.clickToPlay) {
      this.style.cursor = 'pointer';
      this.addEventListener('click', this.handleClick);
    }
    this.loadAnimation();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.removeEventListener('click', this.handleClick);
    window.clearTimeout(this.resizeTimer);
    this.observer?.disconnect();
    this.animation?.destroy();
    this.animation = null;
    this.currentUrl = null;
    this.initialized = false;
  }

  readBoolean(name, fallback) {
    if (!this.hasAttribute(name)) return fallback;
    return ['', 'true', '1'].includes(this.getAttribute(name));
  }

  selectedUrl() {
    return window.innerWidth < 750 && this.mobileUrl ? this.mobileUrl : this.desktopUrl;
  }

  handleResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => this.loadAnimation(), 250);
  }

  handleClick() {
    if (!this.animation) return;
    if (this.animation.isPaused) this.animation.play();
    else this.animation.pause();
  }

  observePlayback() {
    this.observer?.disconnect();
    if (this.autoplay) return;
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!this.animation) return;
        if (entry.isIntersecting) {
          this.animation.play();
          if (!this.loop) this.observer.unobserve(this);
        } else if (this.loop) {
          this.animation.pause();
        }
      });
    }, { threshold: 0.3 });
    this.observer.observe(this);
  }

  loadAnimation() {
    const url = this.selectedUrl();
    if (!url || (url === this.currentUrl && this.animation)) return;
    this.currentUrl = url;
    this.animation?.destroy();
    this.animation = window.lottie.loadAnimation({
      container: this,
      renderer: 'svg',
      rendererSettings: { runExpressions: false },
      loop: this.loop,
      autoplay: this.autoplay,
      path: url,
    });
    this.animation.setSpeed(this.speed);
    this.animation.addEventListener('DOMLoaded', () => {
      this.querySelectorAll(':scope > img').forEach((image) => image.hidden = true);
    });
    this.observePlayback();
  }
}

if (!customElements.get('v7-json-animation')) {
  customElements.define('v7-json-animation', StudioJsonAnimation);
}

})();